import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import React from "react";
import MemberSelection from "../general/MemberSelection";
import { MembersFieldDto } from "../../types/membersTypes";

interface EditProjectStaffingCommitteeDialogProps {
  open: boolean;
  onClose: () => void;
  handleStaffingCommitteeSelection: (event: React.SyntheticEvent, value: MembersFieldDto | null) => void;
  addStaffingCommitteeMember: () => void;
  removeStaffingCommitteeMember: (memberId: number) => void;
  staffingCommittee: MembersFieldDto[];
  selectableStaffingCommittee: MembersFieldDto[];
  handleSaveStaffingCommittee: () => void;
}

/**
 * A dialog for editing the staffing committee of a project
 * @param open - Whether the dialog is open
 * @param onClose - The function to call when the dialog is closed
 * @param staffingCommittee - The current staffing committee
 * @param handleStaffingCommitteeSelection - The function to call when a staffing committee member is selected
 * @param addStaffingCommitteeMember - The function to call when a staffing committee member is added
 * @param removeStaffingCommitteeMember - The function to call when a staffing committee member is removed
 * @param selectableStaffingCommittee - The selectable staffing committee members
 * @param handleSaveStaffingCommittee - The function to call when the staffing committee is saved
 */
const EditProjectStaffingCommitteeDialog = ({
  open,
  onClose,
  staffingCommittee,
  handleStaffingCommitteeSelection,
  addStaffingCommitteeMember,
  removeStaffingCommitteeMember,
  selectableStaffingCommittee,
  handleSaveStaffingCommittee,
}: EditProjectStaffingCommitteeDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle fontWeight={"bold"}>Besetzungsgremium bearbeiten</DialogTitle>
      <DialogContent sx={{ paddingBottom: 30 }}>
        <Typography sx={{ marginBottom: 4 }}>Wähle die Mitglieder für das Besetzungsgremium aus.</Typography>
        <MemberSelection
          onChangeCallback={handleStaffingCommitteeSelection}
          addMember={addStaffingCommitteeMember}
          removeMember={removeStaffingCommitteeMember}
          selectedMembers={staffingCommittee}
          selectableMembers={selectableStaffingCommittee}
        />
      </DialogContent>
      <DialogActions sx={{ borderTop: 1, color: "primary.main" }}>
        <Button variant="contained" color="primary" onClick={onClose}>
          Abbrechen
        </Button>
        <Button variant="contained" color="primary" onClick={handleSaveStaffingCommittee}>
          Speichern
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditProjectStaffingCommitteeDialog;
